// The ONE shared, React-free formatter for a portal donation's derived display
// status. Sibling of `contributionTypeLabel` / `paymentMethodLabel`: a pure map,
// so the web dashboard's pill and the mobile feed's badge read the same word for
// the same gift. Each surface keeps its own visual treatment (a Badge variant on
// the web, a tone on mobile) — only the WORD is shared, because that is the part
// a treasurer compares across two screens.

import type { DonationDisplayStatus } from '../generated/enums.gen';

/** Per-status treasurer-facing label, keyed by the wire enum value. */
export const DONATION_STATUS_LABELS: Record<DonationDisplayStatus, string> = {
  Succeeded: 'Succeeded',
  Refunded: 'Refunded',
  Disputed: 'Disputed',
};

/**
 * Resolves the display label for a donation's derived status. Falls back to the raw
 * value for any unexpected (non-enum) input, so a status the wire grows before a
 * client ships still says something rather than rendering a blank badge beside the
 * gift's amount.
 */
export function donationStatusLabel(status: DonationDisplayStatus | string): string {
  return DONATION_STATUS_LABELS[status as DonationDisplayStatus] ?? status;
}
